function appHeight() {
    const doc = document.documentElement
    const headline = document.querySelector('.headline')

    let visibleHeight = 0

    if ( headline ) {
        const rect = headline.getBoundingClientRect()
        const visibleTop = Math.max(rect.top, 0)
        const visibleBottom = Math.min(rect.bottom, window.innerHeight)
        
        visibleHeight = Math.max(visibleBottom - visibleTop, 0)
    }

    doc.style.setProperty('--vh', ( window.innerHeight * 0.01 ) + 'px')
    doc.style.setProperty('--headline', visibleHeight + 'px')
}

window.addEventListener('resize', appHeight)
window.addEventListener('scroll', appHeight)

appHeight()